import { SketchPicker } from "react-color";

const ColorPicker = ({setColor, color}) => {
    const handleChange = (color) =>{
        setColor(color.hex)
    }
  return (
    <div>
      <SketchPicker
        color={color}
        onChangeComplete={handleChange}
        allowNoColor={true} 
      />
    </div>
  );
};

export default ColorPicker;
